import { get, post, blockGet, blockPost, blockPostWithLongTimeout } from '@/services/Http'

export const Auth = {
  login: loginData => post('staff/login', loginData),
  refreshCaptcha: () => get('common/refresh-captcha/'),
  logout: () => get('staff/logout'),
  staffCheck: () => get('staff/check/', {showError: null})
}

export const Home = {
  info: () => blockGet('home-info'),
}

const RoomSelector = {
  getBuildings: () => blockGet('selector/buildings'),
  getRooms: (buildingId, unit) => blockGet(`selector/building/${buildingId}/unit/${unit}/rooms`),
  getBuildingInfo: (buildingId) => blockGet(`selector/building/${buildingId}/building-selects`),
  getRoomInfo: (roomId) => blockGet(`selector/room/${roomId}/room-selects`),
}

export const Role = {
  getAll: () => blockGet('staff-roles'),
  add: newInfo => blockPost('add-staff-role', newInfo),
  update: (roleId, updatedInfo) => blockPost(`staff-role/${roleId}/update`, updatedInfo),
  delete: (roleId, force, showErrorToast) => blockPost(`staff-role/${roleId}/delete`, { force }, { showErrorToast }),
  detail: roleId => blockGet(`staff-role/${roleId}`),
  sort: newSort => blockPost(`rank-staff-roles`, {
    rank: newSort
  })
}

export const Staff = {
  retrieve: (params) => blockGet('staffs', {
    params
  }),
  add: newStaffInfo => blockPost('staff/new', newStaffInfo),
  edit: updateStaffInfo => blockPost(`staff/${updateStaffInfo.id}/edit`, updateStaffInfo),
  remove: id => blockPost(`staff/${id}/delete`),
  getHouseKeeperPerms: staffId => blockGet(`staff/${staffId}/housekeeper-perms`),
  getHouseKeeperInfo: floors => blockPost(`housekeeper-by-floors`, floors),
  updateHouseKeeperPerms: (staffId, perms) => blockPost(`staff/${staffId}/update-housekeeper-perms`, perms)
}

export const House = {
  retrieve: (params) => blockGet('rooms/', {
    params
  }),
  detail: houseId => blockGet(`room/${houseId}`),
  amenityList: () => blockGet(`room-amenities`),
  add: newInfo => blockPost('room/new', newInfo),
  update: updatedInfo => blockPost(`room/${updatedInfo.id}/edit`, updatedInfo),
  delete: id => blockPost(`room/${id}/delete`),
  bulkDelete: roomIdList => blockPost(`room/bulk-delete`, { room_ids: roomIdList }),
  changeLockPassword: (houseId, params) => blockPost(`room/${houseId}/modify_lock_pwd/`, params),
  clearLockFingerPrints: (roomId) => blockPost(`lock/${roomId}/clear-all-fingerprint/`),
  selectorRooms: query => {
    const { building, unit_number: unit, floor } = query
    return blockGet('selector-rooms', {
      params: {
        building,
        unit_number: unit,
        floor
      }
    })
  }
}

export const Building = {
  all: () => blockGet('buildings'),
  add: newInfo => blockPost('building/new', newInfo),
  update: updatedInfo => blockPost(`building/${updatedInfo.id}/edit`, updatedInfo),
  delete: buildingId => blockPost(`building/${buildingId}/delete`)
}

export const Resident = {
  retrieve: (params) => blockGet('residents', {
    params
  }),
  detail: houseId => blockGet(`resident/${houseId}`),
  add: newInfo => blockPost('add-resident', newInfo),
  update: updatedInfo => blockPost(`resident/${updatedInfo.id}`, updatedInfo),
  delete: id => blockPost(`resident/${id}/delete`),
  bulkDelete: residentIdList => blockPostWithLongTimeout(`resident/bulk-delete`, { resident_ids: residentIdList }),
  resetLock: id => blockPostWithLongTimeout(`resident/${id}/lock-pass`)
}

export const Records = {
  retrieve: (params) => blockGet('operation-records', {
    params
  }),
}

export const My = {
  retrieve: () => blockGet('staff/detail'),
  update: updatedInfo => blockPost(`staff/${updatedInfo.id}/edit`, updatedInfo),
  updatePwd: (passwordInfo) => blockPost(`staff/reset-password`, passwordInfo),
}
export const RentHouse = {
  // 合租部分
  retrieveSharedHouse: (params) => blockGet('rental-rooms/', {
    params
  }),
  createSubarea: (roomId) => blockPost(`room/${roomId}/rental-subarea/new`),
  editSubarea: (roomId, subareaId, subareaInfo) => blockPost(`room/${roomId}/rental-subarea/${subareaId}/`, subareaInfo),
  deleteSubarea: (roomId, subareaId) => blockPost(`room/${roomId}/rental-subarea/${subareaId}/delete`),
  surrenderSubarea: (roomId, subareaId) => blockPost(`room/${roomId}/rental-subarea/${subareaId}/surrender`),
  renewSubarea: (roomId, subareaId, date) => blockPost(`room/${roomId}/rental-subarea/${subareaId}/renew`, date),
  // 整租部分
  surrenderEntireHouse: (roomId) => blockPost(`room/${roomId}/surrender`),
  renewEntireHouse: (roomId, date) => blockPost(`room/${roomId}/renew`, date),
}

export const Community = {
  retrieveAnnouncement: (params) => blockGet('notices/', {
    params
  }),
  createAnnouncement: (data) => blockPost('notice/new', data),
  editAnnouncement: (data) => blockPost(`notice/${data.id}/edit`, data),
  deleteAnnouncement: (id) => blockPost(`notice/${id}/delete`),
  retrieveAnnouncementDetail: (id) => blockGet(`notice/${id}`),
}

export const Suggestion = {
  retrieveSuggestion: (params) => blockGet('suggestions/', {
    params
  }),
  replySuggestion: (data, id) => blockPost(`suggestion/${id}/add_note`, data),
  retrieveSuggestionDetail: (id) => blockGet(`suggestion/${id}/`),
}
export const Repair = {
  retrieveRepair: (params) => blockGet('reqs/', {
    params
  }),
  assignReq: (data, id) => blockPost(`req/${id}/assign`, data),
  retrieveReqDetail: (id) => blockGet(`req/${id}`),
  feedbackReq: (data, id) => blockPost(`req/${id}/feedback`, data),
  retrieveWorkers: () => blockGet('/workers'),
  retrieveHistory: (id) => blockGet(`req/${id}/record`),
}
export const Lock = {
  retrieveLocks: (params) => blockGet('locks/', {
    params
  }),
  retrieveAuthHistory: (roomId) => blockGet(`lock/${roomId}/auth-history`),
  resetLock: (id) => blockPost(`resident/${id}/lock-pass`),
}
export const Visitor = {
  retrieveVisitors: (params) => blockGet('visits/', {
    params
  }),
  retrieveVisitorDetail: (id) => blockGet(`visit/${id}/detail`),
}

export default {
  Auth,
  RoomSelector,
  Role,
  Staff
}
